function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 38,
  r: 24,
  transform: "rotate(-180 24 38)",
  fill: "#CACAF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 38L23.5455 23L33.0909 38L23.5455 43.4545L14 38Z",
  fill: "#9FA8DA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 23L33.0914 38L23.5459 43.4545V23Z",
  fill: "#7986CB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 40.0455L23.5455 45.5L33.0909 40.0455L23.5455 53L14 40.0455Z",
  fill: "#9FA8DA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 45.5L33.0914 40.0455L23.5459 53V45.5Z",
  fill: "#7986CB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14 38L23.5455 33.9091L33.0909 38L23.5455 43.4545L14 38Z",
  fill: "#7986CB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 33.9091L33.0914 38L23.5459 43.4545V33.9091Z",
  fill: "#5C6BC0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M103 57C116.255 57 127 46.2548 127 33C127 19.7452 116.255 9 103 9C89.7452 9 79 19.7452 79 33C79 46.2548 89.7452 57 103 57Z",
  fill: "#6E97FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M107.253 40.6318V36.4958H108.388V39.3118H109.77V37.0238H110.852V39.3118H112.278V36.399H113.413V40.6318H107.253Z",
  fill: "#1E1A31"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.253 36.0419V31.1667H108.388V32.9443H113.413V34.2643H108.388V36.0419H107.253Z",
  fill: "#1E1A31"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M107.253 30.4482V29.1282H109.726V26.6818H107.253V25.3618H113.413V26.6818H110.87V29.1282H113.413V30.4482H107.253Z",
  fill: "#1E1A31"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.9422 41.5842L91.1113 40.2779L102.627 24.2775L104.458 25.5837L92.9422 41.5842Z",
  fill: "#1E1A31"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.8745 31.8779H99.4892C102.319 31.8779 104.614 34.1647 104.614 36.9856C104.614 39.8065 102.319 42.0933 99.4892 42.0933H91.9529C91.3312 42.0933 90.8271 41.591 90.8271 40.9713C90.8271 40.3515 91.3312 39.8492 91.9529 39.8492H99.4892C101.076 39.8492 102.362 38.5671 102.362 36.9856C102.362 35.4041 101.076 34.1221 99.4892 34.1221H96.567H96.5665H95.9518C93.1215 34.1221 90.8271 31.8353 90.8271 29.0144C90.8271 26.1935 93.1215 23.9067 95.9518 23.9067H103.488C104.11 23.9067 104.614 24.409 104.614 25.0287C104.614 25.6484 104.11 26.1508 103.488 26.1508H95.9518C94.365 26.1508 93.0787 27.4329 93.0787 29.0144C93.0787 30.5959 94.365 31.8779 95.9518 31.8779H98.874C98.8742 31.8779 98.8743 31.8779 98.8745 31.8779Z",
  fill: "#1E1A31"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M76.8449 63.7127L77.06 64.164L77.06 64.164L76.8449 63.7127ZM81.5086 61.0976C81.7689 61.1899 81.9051 61.4756 81.8129 61.7359L80.3099 65.9775C80.2177 66.2378 79.9319 66.374 79.6717 66.2818C79.4114 66.1896 79.2751 65.9038 79.3674 65.6435L80.7033 61.8732L76.933 60.5372C76.6728 60.445 76.5365 60.1592 76.6287 59.899C76.721 59.6387 77.0067 59.5024 77.267 59.5947L81.5086 61.0976ZM76.6297 63.2613L81.1265 61.1176L81.5568 62.0202L77.06 64.164L76.6297 63.2613ZM48.6143 61.4593C57.008 66.8789 67.6109 67.5609 76.6297 63.2613L77.06 64.164C67.728 68.6129 56.757 67.9072 48.0719 62.2994L48.6143 61.4593Z",
  fill: "#484697"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0505 9.20105L50.8092 8.76309L50.8092 8.76309L51.0505 9.20105ZM46.5479 12.0848C46.2826 12.008 46.1299 11.7307 46.2067 11.4654L47.4587 7.14308C47.5355 6.87784 47.8128 6.7251 48.078 6.80192C48.3433 6.87875 48.496 7.15604 48.4192 7.42129L47.3064 11.2634L51.1484 12.3762C51.4137 12.453 51.5664 12.7303 51.4896 12.9956C51.4128 13.2608 51.1355 13.4135 50.8702 13.3367L46.5479 12.0848ZM51.2917 9.63901L46.9282 12.0425L46.4458 11.1666L50.8092 8.76309L51.2917 9.63901ZM79.3645 9.79697C70.6678 4.87831 60.0432 4.81853 51.2917 9.63901L50.8092 8.76309C59.8646 3.77523 70.8582 3.8371 79.8568 8.92654L79.3645 9.79697Z",
  fill: "#484697"
});

var SvgBorrowSEth = function SvgBorrowSEth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 71,
    viewBox: "0 0 127 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBorrowSEth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/borrow-sETH.67e8db96.svg";
export { ForwardRef as ReactComponent };